export default "__VITE_ASSET__iAjPnaSe__"